(function ($) {
  "use strict";
  jQuery(document).ready(function(){
/*--
Menu Sticky
-----------------------------------*/
var windows = $(window);
var sticky = $('.header-sticky');
windows.on('scroll', function() {
  var scroll = windows.scrollTop();
  if (scroll < 100) {
    sticky.removeClass('is-sticky');
  }else{
    sticky.addClass('is-sticky');
  }
});


    $("button.navbar-toggler").click(function(){
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    });
    $(".close-box").click(function(){
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $(".mm-fullscreen-bg").click(function(){
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });

    $(".shopping-cart a.cart-count").click(function(){
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $(".shopping-cart-close i").click(function(){
      $(".mini-cart").removeClass("show");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    $(".mm-fullscreen-bg").click(function(){
      $(".mini-cart").removeClass("show");
      $(".mm-fullscreen-bg").removeClass("active");
    });

    // add to cart js via product show mini-cart
    $(".add-to-cart").on('click', function() {
      window.setTimeout(function(){
        $(".mini-cart ").addClass("show");
        $(".mm-fullscreen-bg").addClass("active");
        $("body").addClass("hidden");
      }, 1000);
    });
    $(".shopping-cart-close").on('click', function() {
      if ($('.mini-cart ').hasClass('show')) {
        $('.mini-cart ').removeClass('show');
      }
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $(".mm-fullscreen-bg").on('click', function() {
      $(".mini-cart").removeClass("show");
      $(".mm-fullscreen-bg").removeClass("active");
    });

    
$('.full-view').on('click', function(e){
  //$('.product_detail_img').magnificPopup('open');
//   e.preventDefault();
  $('.product_detail_img').magnificPopup({
    delegate: 'a',
    type:'image',
    showCloseBtn: true,
    closeBtnInside: false,
    midClick: true,
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0,1]
    }
  }).magnificPopup('open');
});


/* ===================================
masonry
====================================== */

$('.grid').imagesLoaded(function () {
    $('.grid').isotope({
        itemSelector: 'li',
        layoutMode: 'masonry'
    });
});

$(window).scroll(function(){
  if ($(this).scrollTop() > 1000) {
    $('#top').fadeIn();
  } else {
    $('#top').fadeOut();
  }
});
$('#top').click(function(){
  $("html, body").animate({ scrollTop: 0 }, 600);
  return false;
});
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})

});
})(jQuery);